import { Form } from '@ant-design/compatible';
import { Select } from 'antd';
import React, { useState } from 'react';
import { normalizePhoneNumbers, phoneNumberValidator } from './index';

const AsYouTypeFormatter = require('google-libphonenumber').AsYouTypeFormatter;

/**
 * antd v3 (@ant-design/compatible) counterpart to MultiPhoneNumberComponent, for forms still
 * built on Form.create()/getFieldDecorator. Reuses the shared phoneNumberValidator and
 * normalizePhoneNumbers so validation/formatting stays identical to the v4 component.
 */
export default function MultiPhoneNumberComponentAntdV3({ form, fieldProps, ...props }) {
	const [searchValue, setSearchValue] = useState('');

	return (
		<Form.Item label={props.label || 'Phone Numbers'}>
			{form.getFieldDecorator(fieldProps.name, {
				...fieldProps,
				normalize: normalizePhoneNumbers,
				rules: [...(fieldProps.rules || []), { validator: phoneNumberValidator }],
				validateTrigger: ['onChange'],
			})(
				<Select
					mode="tags"
					open={false}
					allowClear={true}
					optionFilterProp="label"
					tokenSeparators={[',', ';', ':']}
					placeholder="Enter phone numbers"
					searchValue={searchValue}
					onSearch={(value) => {
						const formatter = new AsYouTypeFormatter('US');
						const phoneString = value.replace(/[^0-9+]/g, '').split('');
						phoneString.map((character) => formatter.inputDigit(character));
						setSearchValue(formatter.currentOutput_.toString());
					}}
					onSelect={() => setSearchValue('')}
					{...props.selectProps}
				/>
			)}
		</Form.Item>
	);
}
